import { ReactNode } from "react";
import { Box } from "@mui/material";

type IconBoxProps = {
  borderColor: string;
  children: ReactNode;
};

export const IconBox = ({ children, borderColor }: IconBoxProps) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 32,
      height: 32,
      borderRadius: "50%",
      borderColor,
      borderStyle: "solid",
      borderWidth: "2px",
    }}
  >
    {children}
  </Box>
);
